'use strict';

export default function routes($stateProvider) {
  'ngInject';

  $stateProvider.state('main.compare_graph_index', {
    url: 'compare',
    template: '<compare-graph-index></compare-graph-index>'
  });
}



// WEBPACK FOOTER //
// ./public/dev/app/compare-graph/index/compare-graph-index.routes.js